import { createApp } from 'vue'
import App from './App.vue'
import "./assets/bootstrap-grid.css";
import "./assets/color-scheme.css";
import '@dk.onlinefundraising/onboarding-utils/src/assets/style/style.scss';
import * as Sentry from "@sentry/vue";

sessionStorage.setItem('onboardingUrl', process.env.VUE_APP_ONBOARDING_API_URL);

const app = createApp(App);


Sentry.init({
    app,
    dsn: "https://a3adfc7e151ae7d592206b1adcb06ee9@sentry.onlinefundraising.dk/54",
    sendDefaultPii: true,
    enableTracing: true,
    attachStacktrace: true,
    environment: process.env.NODE_ENV,

    integrations: [

        Sentry.browserTracingIntegration(),
        Sentry.breadcrumbsIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false
        }),
        Sentry.httpClientIntegration(
            {
                failedRequestStatusCodes: [400, 599] // Capture 4xx-5xx errors
            }
        ), // HTTP request tracking
        Sentry.httpContextIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['warn', 'error'] // Only capture warnings/errors
        }), // Console logs
        Sentry.contextLinesIntegration(), // Source code context
        Sentry.linkedErrorsIntegration()
    ],

    // We recommend adjusting this value in production
    tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // This sets the sample rate for session replay and is optional
    replaysSessionSampleRate: 1.0, // Capture 10% of user sessions for replay
    replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with an error
});

app.mount("#app");